import { create } from 'zustand'
import { generateShades, BRAND_SHADE_KEYS } from '../utils/colorShades'

interface ThemeState {
  brandColorPrimary: string | null
  brandColorSecondary: string | null
  logoUrl: string | null
  applyBranding: (branding: {
    brand_color_primary?: string | null
    brand_color_secondary?: string | null
    logo_url?: string | null
  }) => void
  resetBranding: () => void
}

function setShadeVariables(baseHex: string | null | undefined) {
  const root = document.documentElement
  if (!baseHex) {
    BRAND_SHADE_KEYS.forEach((shade) => root.style.removeProperty(`--brand-primary-${shade}`))
    return
  }
  const shades = generateShades(baseHex)
  if (!shades) return
  Object.entries(shades).forEach(([shade, hex]) => {
    root.style.setProperty(`--brand-primary-${shade}`, hex)
  })
}

function setSecondaryVariable(baseHex: string | null | undefined) {
  const root = document.documentElement
  if (baseHex) {
    root.style.setProperty('--brand-secondary', baseHex)
  } else {
    root.style.removeProperty('--brand-secondary')
  }
}

export const useThemeStore = create<ThemeState>()((set) => ({
  brandColorPrimary: null,
  brandColorSecondary: null,
  logoUrl: null,
  applyBranding: (branding) => {
    setShadeVariables(branding.brand_color_primary)
    setSecondaryVariable(branding.brand_color_secondary)
    set({
      brandColorPrimary: branding.brand_color_primary ?? null,
      brandColorSecondary: branding.brand_color_secondary ?? null,
      logoUrl: branding.logo_url ?? null,
    })
  },
  resetBranding: () => {
    setShadeVariables(null)
    setSecondaryVariable(null)
    set({ brandColorPrimary: null, brandColorSecondary: null, logoUrl: null })
  },
}))
